<template>
    <div>
        <!--- start Btn -->
        <div @click="m_startTrivia_f"
             class="TQ_padding_8px TQ_inline TQ_text_24px TQ_borderRadius TQ_bg_purple"
             v-if="!co_startTime_b">
            {{ass_strings.twoWords_startTrivia[p_qb_displayLangCode_e]}}
        </div>

        <!-- user answers-->
        <div v-else-if="co_finishTrivia_b" class="TQ_bg_gray4 TQ_padding_4px TQ_borderBox">

            <div v-for="(qbrl_question_c, questionIndex_n) in p_rd_lock_c.qbrl_questions_ac" class="TQ_margin_8px_0 TQ_grid_row_1frAuto">

                <div v-for="ansIndex in qbrl_question_c.qbrlq_ansNum_blc_n[p_qb_displayLangCode_e]" class="TQ_bg_white">

                    <div v-html="p_rd_lock_c.qbrl_questions_ac[questionIndex_n].qbrlq_body_blc_c[p_qb_displayLangCode_e].w_body_s" class="TQ_padding_8px"> </div>

                    <!-- lock question-->
                    <div class="TQ_align_initial TQ_border_top TQ_padding_8px TQ_grid_col_Auto1frAuto">

                        <div class="TQ_verticalAlignMiddle TQ_inline">
                            {{ass_strings.oneWord_answer[p_qb_displayLangCode_e]}}:
                            {{p_rd_lock_c.qbrl_questions_ac[questionIndex_n].qbrlq_ans_blc_ac[p_qb_displayLangCode_e][0]}}
                        </div>
                        <div></div>

                        <div v-if="m_correctAnswer_f(questionIndex_n)" class="TQ_bg_green TQ_padding_4px TQ_borderRadius">
                            <img :src="ass_img_oneStar_w" class="TQ_width_14px TQ_verticalAlignMiddle "/>
                            <div class="TQ_inline TQ_padding_2px TQ_verticalAlignMiddle"></div>
                            <div class="TQ_verticalAlignMiddle TQ_inline TQ_text_bold">{{p_rd_lock_c.qbrl_points_n/p_rd_lock_c.qbrl_questions_ac.length}}+</div>
                        </div>

                        <img  v-else :src="ass_img_xLetter_w" class="TQ_width_14px TQ_verticalAlignMiddle TQ_padding_4px TQ_bg_red TQ_borderRadius"/>
                    </div>

                </div>
            </div>

        </div>

        <!-- start trivia -->
        <div v-else-if="co_secondsPast_n > -1">

            <!-- timer -->
            <tq-timer :p_second-pass_n="co_secondsPast_n"
                      :p_total-time_n="p_rd_lock_c.qbrl_totalTimeInSeconds_n"
                      :pe_time-over_f="m_timerTimeOverCb_f"/>

            <!-- trivia questions -->
            <div class="TQ_bg_gray4 TQ_padding_4px_0">

                <div class="TQ_bg_white TQ_padding_4px">

                    <!-- trivia body  -->
                    <div v-html="p_rd_lock_c.qbrl_questions_ac[currentQuestionIndex_n].qbrlq_body_blc_c[p_qb_displayLangCode_e].w_body_s" class="TQ_padding_8px"> </div>
                    <hr>

                    <!-- questions -->
                    <div v-for="ansIndex in co_currentQuestion_c.qbrlq_ansNum_blc_n[p_qb_displayLangCode_e]" class="TQ_grid_col_1fr1fr TQ_grid_gap_8px TQ_margin_8px">


                        <!-- lock question-->
                        <div @click="m_clickOption_f(index_n)"
                             class="TQ_inline TQ_border TQ_padding_8px TQ_box_shadow "
                             :class="co_currentSelectedQuestionOptionIndex_n === index_n ? 'TQ_bg_green' : 'TQ_bg_gray4' "
                             v-for="(option, index_n) in co_currentQuestion_c.qbrlq_ansOptions_blc_ac[p_qb_displayLangCode_e]">
                            {{option}}
                        </div>

                    </div>
                    <hr>

                    <!-- btns -->
                    <div class="TQ_margin_8px TQ_grid_col_Auto1frAuto">

                        <!-- back -->
                        <div @click="m_clickBackBtn_n">
                            <div class="TQ_inline TQ_padding_8px TQ_bg_gray1 TQ_textColor_white TQ_borderRadius TQ_box_shadow TQ_text_20px " v-if="currentQuestionIndex_n > 0">
                                {{ass_strings.oneWord_back[p_qb_displayLangCode_e]}}
                            </div>
                        </div>

                        <!-- space -->
                        <div></div>

                        <!-- continue -->
                        <div @click="m_clickContinue_f"
                             class="TQ_padding_8px TQ_bg_purple TQ_borderRadius TQ_box_shadow TQ_text_20px ">
                            {{ass_strings.oneWord_Continue[p_qb_displayLangCode_e]}}
                        </div>

                    </div>

                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import {
        validator_class_fb,
        validator_enum_fb,
        validator_null_fb
    } from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_langCodes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {date_getTimePastInSeconds_fn, date_newDate_fd, date_setTimeout} from "../../scripts/S_Date";
    import TqTimer from "../basic/TqTimer";
    import {
        ass_img_checked, ass_img_oneStar_w,
                ass_img_xLetter_w
    } from "../../assets/scripts/Ass_Files";
    import {notification_notify2} from "../../scripts/S_Notification";
    import {
        FB_QuestBody_Riddle_Lock,
        FB_RiddleStatus_unlockData
    } from "../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "TqTrivia",
        components: {TqTimer},
        props:{
            p_userId_uid:{
                type:String,
                require: true,
            },
            p_rd_lock_c:{
                type:FB_QuestBody_Riddle_Lock,
                require: true,
            },
            p_rs_unlockData_c:{
                type:Object,
                require: true,
                validator(val){
                    return validator_null_fb(val) || validator_class_fb(val, FB_RiddleStatus_unlockData)
                }
            },
            p_qb_displayLangCode_e:{
                type: String,
                require: true,
                validator(val){
                    return validator_enum_fb(enum_langCodes, val)
                }
            },
            pe_startTrivia_f:{
                type:Function,
                require: true
            },
            pe_finishTrivia_f:{
                type:Function,
                require: true
            }
        },
        data(){
           return {
               currentQuestionIndex_n   : 0,
               questionsAnsIndex_byQuestionIndex_n : {},
               startingTime_t           : null,
               startTrivia_t            : null,
               ass_strings              : ass_strings,
               ass_img_oneStar_w        : ass_img_oneStar_w,
               ass_img_xLetter_w        : ass_img_xLetter_w,
           }
        },
        computed:{
            co_currentQuestion_c(){
                return this.p_rd_lock_c.qbrl_questions_ac[this.currentQuestionIndex_n]
            },
            co_currentSelectedQuestionOptionIndex_n(){
                return this.questionsAnsIndex_byQuestionIndex_n[this.currentQuestionIndex_n]
            },
            co_startTime_b(){
                 return this.co_secondsPast_n > -1
            },
            co_finishTrivia_b(){
                return this.co_secondsPast_n >= this.p_rd_lock_c.qbrl_totalTimeInSeconds_n
            },
            co_secondsPast_n(){
                if(this.startTrivia_t == null){
                    return -1
                }
                return date_getTimePastInSeconds_fn(this.startTrivia_t)
            }
        },
        methods:{
            m_clickOption_f(index_n){
                this.$set(this.questionsAnsIndex_byQuestionIndex_n, this.currentQuestionIndex_n, index_n)
            },
            m_clickContinue_f(){

                if(this.questionsAnsIndex_byQuestionIndex_n[this.currentQuestionIndex_n] == null){
                    notification_notify2({
                        title_s : ass_strings.oneWord_error[this.p_qb_displayLangCode_e],
                        text_s : ass_strings.threeWords_pleaseSelectAnswer[this.p_qb_displayLangCode_e]
                    })
                    return
                }

                if(this.currentQuestionIndex_n < this.p_rd_lock_c.qbrl_questions_ac.length -1){
                    this.currentQuestionIndex_n++;
                }else{
                    this.m_timerTimeOverCb_f()
                }
            },
            m_clickBackBtn_n(){
                this.currentQuestionIndex_n--;
            },
            m_startTrivia_f(){
                this.pe_startTrivia_f((setData_b) =>{
                    if(setData_b){
                        this.startTrivia_t = (date_newDate_fd()).getTime()
                    }
                })
            },
            m_timerTimeOverCb_f(){
                this.startTrivia_t -= 1000 * this.p_rd_lock_c.qbrl_totalTimeInSeconds_n

                let ans_byQuestionIndex_as = {}
                for(let questionIndex_n in this.questionsAnsIndex_byQuestionIndex_n){
                    let ansIndex_n = this.questionsAnsIndex_byQuestionIndex_n[questionIndex_n]

                    let userAns_s = this.p_rd_lock_c.qbrl_questions_ac[questionIndex_n].qbrlq_ansOptions_blc_ac[this.p_qb_displayLangCode_e][0]
                    let ans_s = this.p_rd_lock_c.qbrl_questions_ac[questionIndex_n].qbrlq_ans_blc_ac[this.p_qb_displayLangCode_e][0]

                    if(userAns_s === ans_s){
                        ans_byQuestionIndex_as[questionIndex_n] =[ this.p_rd_lock_c.qbrl_questions_ac[questionIndex_n].qbrlq_ansOptions_blc_ac[this.p_qb_displayLangCode_e][ansIndex_n]]
                    }

                }

                this.pe_finishTrivia_f(ans_byQuestionIndex_as, this.startTrivia_t, () =>{})
            },
            m_correctAnswer_f(questionIndex_n){

                if(this.p_rs_unlockData_c.rsud_quizUserAns_byQuestionIndex_as[questionIndex_n] == null){
                    return false
                }


                return this.p_rs_unlockData_c.rsud_quizUserAns_byQuestionIndex_as[questionIndex_n] != null
            }
        },
        watch:{
            'p_rs_unlockData_c.rsud_finishTime_t':{
                handler(timestamp_n){
                    if(this.startTrivia_t == null && timestamp_n){
                        this.startTrivia_t = this.p_rs_unlockData_c.rsud_timestemp_t
                    }
                },
                immediate:true
            }
        },
    }
</script>

<style scoped>

</style>